export function parseLocation(location) {
  const {
    isAgreed
  } = location || {};
  return {
    isAgreed: typeof isAgreed === 'boolean' ? isAgreed : false
  };
}